module.exports = __webpack_public_path__ + "img/blob1.00f2eee0.svg";